<template>
    <div class="app-left-content-header">
        <h1 class="content-title">Aplicaciones en Sistema</h1>
        <button class="add-app-button" @click="openAddModal">Agregar Aplicación</button>
        <button class="add-app-button-mobile" @click="openAddModal"><i class="bi bi-window-plus"></i></button>
        <ModalAddApp v-model="showAddModal" />
    </div>
    <div class="app-content-field">
        <div class="container">
            <div class="table-filter-wrapper">
                <input class="filter-search-input" type="text" placeholder="Buscar en la tabla..." />
            </div>
            <ul class="responsive-table">
                <li class="table-header">
                    <div class="col col-1">Nombre</div>
                    <div class="col col-2">Modulos</div>
                    <div class="col col-3">Estado</div>
                    <div class="col col-4"></div>
                </li>
                <li class="table-row">
                    <div class="col col-1" data-label="Nombre">Fletes</div>
                    <div class="col col-2" data-label="Modulos">Activo</div>
                    <div class="col col-3" data-label="Estado">Activo</div>
                    <div class="col col-4" data-label="">
                        <button class="edit-button" @click="openEditModal"><i class="bi bi-pen-fill"></i></button>
                        <ModalEditApp v-model="showEditModal" />
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import ModalAddApp from '@/components/ModalAddApp.vue';
import ModalEditApp from '@/components/ModalEditApp.vue';

const showAddModal = ref(false);
const showEditModal = ref(false);

const openEditModal = () => {
    showEditModal.value = true;
};
const openAddModal = () => {
    showAddModal.value = true;
};

</script>

<style scoped src="../styles/appsPanel.css"></style>
<style scoped src="../styles/tableAppsPanel.css"></style>
